<div class="contact container-fluid">
    <section class="ftco-section">
        <div class="container-fluid">
            <div class="row ">
                <div class="col-md-6 mb-3"
                    style="display: flex;flex-direction: column;justify-content: start;align-items: center;">
                    <h2 class="borderLine" translate>contact</h2>
                </div>
            </div>
            <div class="boxstyle row justify-content-center">
                <div class="col-lg-9 col-md-12">
                    <div class="wrapper">
                        <div class="row no-gutters">
                            <div class="col-md-7 d-flex align-items-stretch">
                                <div class="contact-wrap w-100 p-md-5 p-4" style="box-shadow: 18px 2px 18px gray;">
                                    <h3 class="mb-4" translate>form</h3>
                                    <div id="form-message-warning" class="mb-4"></div>
                                    <div id="form-message-success" class="mb-4">
                                        Your message was sent, thank you!
                                    </div>
                                    <form id="contactForm" name="contactForm" #form="ngForm">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" name="name" id="name" ngModel
                                                    [placeholder]="'name-placeholder' | translate">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input type="email" class="form-control" name="email" id="email" ngModel
                                                        placeholder="Email">
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" name="subject" id="subject" ngModel
                                                    [placeholder]="'topic' | translate">
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <textarea name="text" class="form-control" id="text" cols="30" ngModel
                                                        rows="7" [placeholder]="'message' | translate"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <re-captcha id="recaptcha" name="recaptcha" #recaptcha="ngModel"
                                                    [(ngModel)]="token" required
                                                    [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
                                                <div *ngIf="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"
                                                    class="invalid-feedback">
                                                    <div *ngIf="recaptcha.errors?.required" translate>required</div>
                                                </div>
                                            </div>
                                            <div class="col-md-12" style="margin-top: 1rem;">
                                                <div class="form-group">
                                                    <button [value]="'send' | translate" class="btn btn-primary"  (click)="send(form)" translate>send</button>
                                                    <div class="submitting"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-md-5 d-flex align-items-stretch">
                                <div class="info-wrap bg-primary w-100 p-lg-5 p-4" style="box-shadow: 15px 2px 18px gray;">
                                    <h3 class="mb-4 mt-md-4" translate>cdetails</h3>
                                    <div class="dbox w-100 d-flex align-items-start">
                                        <div class="icon d-flex align-items-center justify-content-center">
                                            <span class="material-icons">pin_drop</span>
                                        </div>
                                        <div class="text pl-3">
                                            <p><span translate>address</span><br> <a translate>street</a>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="dbox w-100 d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center">
                                            <span class="material-icons">phone</span>
                                        </div>
                                        <div class="text pl-3">
                                            <p><span>Tel.:</span> <br> <a href="tel://2251028431"> +30 2251028431, +30
                                                    2251029727</a></p>
                                        </div>
                                    </div>
                                    <div class="dbox w-100 d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center">
                                            <span class="material-icons">alternate_email</span>
                                        </div>
                                        <div class="text pl-3">
                                            <p><span>Email:</span> <br>
                                                <a href="mailto:info@lesvos-chamber.com">info@lesvos-chamber.com</a>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="dbox w-100 d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center">
                                            <span class="material-icons">schedule</span>
                                        </div>
                                        <div class="text pl-3">
                                            <p><span translate>time</span><br> <a href="#">8:00 - 14:00</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
       
    </section>
     <div class="container-fluid">
            <div class="row map">

                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3096.032196780759!2d26.556279976447435!3d39.10573713438367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ba6709bcbfce19%3A0x812729c0f2ff9c08!2zzpXOoM6ZzpzOlc6bzpfOpM6XzqHOmc6fIM6bzpXOo86Szp_OpQ!5e0!3m2!1sel!2sus!4v1683030979100!5m2!1sel!2sus"
                    class="w-100" height="400" style="border:0;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>

            </div>
        </div>
</div>